import { render, staticRenderFns } from "./TareasArchivos.vue?vue&type=template&id=c04c8840"
import script from "./TareasArchivos.vue?vue&type=script&lang=js"
export * from "./TareasArchivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports